/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sales_Debtor_No_CustomersInputs */

const vi_dashboard_sales_debtor_no_customers = /** @type {(inputs: Dashboard_Sales_Debtor_No_CustomersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có khách phụ trách`)
};

/**

* @param {Dashboard_Sales_Debtor_No_CustomersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_sales_debtor_no_customers = /** @type {((inputs?: Dashboard_Sales_Debtor_No_CustomersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sales_Debtor_No_CustomersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_sales_debtor_no_customers(inputs)
});